import { getAxiosInstance } from "../../../api";

export const getBillToMappingData = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/bill-to-mapping/edit?bill_to_mapping_id=${id}`
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const createBillToMapping = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/bill-to-mapping/create`, body);
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const editBillToMapping = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/bill-to-mapping/update`, body);
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteBillToMapping = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.delete(`/bill-to-mapping/delete`, {
      data: body,
    });
    return response;
  } catch (error) {
    return error.response.data;
  }
};
